import { render, staticRenderFns } from "./McLabel.vue?vue&type=template&id=7be9ad52&scoped=true&"
import script from "./McLabel.vue?vue&type=script&lang=js&"
export * from "./McLabel.vue?vue&type=script&lang=js&"
import style0 from "./McLabel.vue?vue&type=style&index=0&id=7be9ad52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be9ad52",
  null
  
)

component.options.__file = "McLabel.vue"
export default component.exports